const Theme = {
  colors: {
    light: {
      primary: '#eee',
      secondary: '#ddd',
    },
    dark: {
      primary: '#222',
      secondary: '#444',
    },
    red: '#ff8585',
    green: '#85ffb3',
  },
  padding: {
    sm: '1rem',
    md: '2rem',
    lg: '4rem',
  },
  width: {
    sm: '500px',
    md: '1000px',
    lg: '1500px',
  },
  borderRadius: {
    sm: '5px',
    md: '10px',
    lg: '20px',
  },
}

export default Theme
